module.exports = __webpack_public_path__ + "img/phone-sentosa.61046b68.svg";